import {
    CREATE_FEEDBACK_REQUEST,
    CREATE_FEEDBACK_SUCCESS,
    CREATE_FEEDBACK_FAIL,
    CREATE_FEEDBACK_RESET,
    GET_FEEDBACK_REQUEST,
    GET_FEEDBACK_SUCCESS,
    GET_FEEDBACK_FAIL,
    GET_FEEDBACK_RESET,
    GET_FEEDBACK_CONTENT_REQUEST,
    GET_FEEDBACK_CONTENT_SUCCESS,
    GET_FEEDBACK_CONTENT_FAIL,
    GET_FEEDBACK_CONTENT_RESET,
    GET_CALL_TYPES_REQUEST,
    GET_CALL_TYPES_SUCCESS,
    GET_CALL_TYPES_FAIL,
} from '../constants/feedbackConstants'

export const feedbackCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_FEEDBACK_REQUEST:
            return { loading: true }
        case CREATE_FEEDBACK_SUCCESS:
            return { loading: false, success: true, feedback: action.payload }
        case CREATE_FEEDBACK_FAIL:
            return { loading: false, error: action.payload }
        case CREATE_FEEDBACK_RESET:
            return {}
        default:
            return state
    }
}

export const feedbackListReducer = (state = { feedbacks: [] }, action) => {
    switch (action.type) {
        case GET_FEEDBACK_REQUEST:
            return { loading: true, feedbacks: [] }
        case GET_FEEDBACK_SUCCESS:
            return { loading: false, feedbacks: action.payload }
        case GET_FEEDBACK_FAIL:
            return { loading: false, error: action.payload }
        case GET_FEEDBACK_RESET:
            return { feedbacks: [] }
        default:
            return state
    }
}

export const feedbackContentReducer = (state = { content: '' }, action) => {
    switch (action.type) {
        case GET_FEEDBACK_CONTENT_REQUEST:
            return { ...state, loading: true }
        case GET_FEEDBACK_CONTENT_SUCCESS:
            // Assuming payload is an object with a 'content' field, e.g., { content: "Fetched text" }
            // Or if the payload IS the content string directly, use action.payload
            return { loading: false, content: action.payload, success: true } 
        case GET_FEEDBACK_CONTENT_FAIL:
            return { ...state, loading: false, error: action.payload }
        case GET_FEEDBACK_CONTENT_RESET:
            return { content: '' }
        default:
            return state
    }
}

export const callTypesReducer = (state = { callTypes: [] }, action) => {
    switch (action.type) {
        case GET_CALL_TYPES_REQUEST:
            return { loading: true, callTypes: [] }
        case GET_CALL_TYPES_SUCCESS:
            return { loading: false, callTypes: action.payload, success: true }
        case GET_CALL_TYPES_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
} 